module.exports = __webpack_public_path__ + "static/media/cdt.f65a6ba1.svg";